<section>
  <div class="content-container">
    <p class="subtitle" data-translation-key="communication_preferences_note">
      {{ "communication_preferences.note" | translate }}
    </p>
    @if (hasChanges()) {
      <div
        class="changes-summary"
        data-translation-key="communication_preferences_unsaved_changes"
        >
        <mat-icon>info</mat-icon>
        <span>{{ "communication_preferences.unsaved_changes" | translate }}</span>
      </div>
    }
    <!-- Bulk Actions -->
    @if (types.length > 0 && channels.length > 0) {
      <div class="bulk-actions">
        <button
          (click)="selectAll()"
          class="bulk-btn"
          [disabled]="isSaving"
          data-translation-key="communication_preferences_select_all"
          >
          <mat-icon>select_all</mat-icon>
          {{ "communication_preferences.select_all" | translate }}
        </button>
        <button
          (click)="deselectAll()"
          class="bulk-btn"
          [disabled]="isSaving"
          data-translation-key="communication_preferences_deselect_all"
          >
          <mat-icon>clear</mat-icon>
          {{ "communication_preferences.deselect_all" | translate }}
        </button>
      </div>
    }
    <table class="preferences-matrix" [formGroup]="preferencesForm">
      <!-- Header Row -->
      <thead>
        <tr class="matrix-header">
          <th
            class="header-cell type-header"
            data-translation-key="communication_preferences_communication_type"
            >
            {{ "communication_preferences.communication_type" | translate }}
          </th>
          @for (channel of channels; track channel) {
            <th
              class="header-cell channel-header"
              >
              @if (channel.icon) {
                <i class="bi bi-{{ channel.icon }}"></i>
              }
              {{ channel.name }}
            </th>
          }
        </tr>
      </thead>

      <!-- Data Rows -->
      <tbody>
        @for (type of types; track type) {
          <tr
            class="matrix-row"
            [class.odd-row]="isOddRow(type.id)"
            >
            <!-- Type Name Cell -->
            <td class="type-cell">
              <span class="type-name">{{ type.name }}</span>
            </td>
            <!-- Channel Checkboxes -->
            @for (channel of channels; track channel) {
              <td class="checkbox-cell">
                <mat-checkbox
                  [formControlName]="getControlName(type.id, channel.id)"
                  (change)="onPreferenceChange(type.id, channel.id, $event)"
                  class="preference-checkbox"
                  >
                </mat-checkbox>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

    <!-- Show message if no data -->
    @if (types.length === 0 || channels.length === 0) {
      <div
        class="no-data"
        data-translation-key="communication_preferences_no_data_found"
        >
        <mat-icon>info</mat-icon>
        <p>{{ "communication_preferences.no_data_found" | translate }}</p>
      </div>
    }

    <!-- Changes Summary -->
  </div>

  <div class="content-footer">
    <button
      class="btn btn-primary"
      (click)="savePreferences()"
      [disabled]="isSaving"
      >
      @if (isSaving) {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
          data-translation-key="communication_preferences_save_preferences"
        ></span>
      }
      {{
      isSaving
      ? ("communication_preferences.saving" | translate)
      : ("communication_preferences.save_preferences" | translate)
      }}
    </button>
  </div>
</section>
